// extracted by mini-css-extract-plugin
export default {"breadcrumbNav":"BreadCrumb_breadcrumbNav__HLudj","breadcrumb":"BreadCrumb_breadcrumb__F8HTG","breadcrumbItem":"BreadCrumb_breadcrumbItem__hx0t4","active":"BreadCrumb_active__255fh"};